class EmployeeModel {
  position = null;
  personnel_number = null;
  service_id = null;

  constructor(employeeData) {
    if (employeeData !== undefined) {
      let { position, personnel_number, service_id } = employeeData;
      Object.assign(this, {
        position,
        personnel_number,
        service_id
      });
    }
  }
}

export default EmployeeModel;
